"use client"

import {
  type ItemPageType,
  useItemActiveLinkChecker,
  useItemPageHref,
} from "@/app/navigation/item"
import type { NftId } from "@anaconda/core/nft/types"
import { NavigationTrigger } from "@rarible_int/anaconda_ui_components"
import BaseLink from "next/link"

export function NftPageLink(props: {
  children: React.ReactNode
  pageType: ItemPageType
  nftId: NftId
}) {
  const active = useItemActiveLinkChecker(props.nftId, props.pageType)
  const href = useItemPageHref(props.nftId, props.pageType)

  return (
    <BaseLink href={href}>
      <NavigationTrigger active={active}>{props.children}</NavigationTrigger>
    </BaseLink>
  )
}
